import { fileUrl } from '@/utils/fileUrl'

interface PersonThumbnailProps {
  /** Absolute or relative URL returned directly from the persons list API. */
  photoUrl?: string | null
  /** Pixel size of the square thumbnail. */
  size?: number
  /** Alt text — usually the person's display name. */
  alt?: string
}

/**
 * Square avatar-style thumbnail. The URL is supplied by the caller — the
 * persons list API now returns thumbnail_photo_url inline so no extra fetch
 * is needed per row.
 */
export function PersonThumbnail({ photoUrl, size = 40, alt = '' }: PersonThumbnailProps) {
  const wrapperStyle = { width: size, height: size }

  if (!photoUrl) {
    return (
      <img
        src="/images/contact-image.png"
        alt={alt || 'No photo'}
        className="shrink-0 rounded-md object-cover"
        style={wrapperStyle}
      />
    )
  }

  return (
    <img
      src={fileUrl(photoUrl)}
      alt={alt}
      className="shrink-0 rounded-md object-cover bg-gray-100 dark:bg-gray-800"
      style={wrapperStyle}
      loading="lazy"
    />
  )
}
